import * as React from "react";
const IconDumbbell = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M61 29.8h-2.2v-.2c0-3.9-3.2-7.2-7.2-7.2s-7.2 3.2-7.2 7.2v.2H19.6v-.2c0-3.9-3.2-7.2-7.2-7.2s-7.2 3.2-7.2 7.2v.2H3c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2h2.3v.2c0 3.9 3.2 7.2 7.2 7.2s7.2-3.2 7.2-7.2v-.2h24.9v.2c0 3.9 3.2 7.2 7.2 7.2s7.2-3.2 7.2-7.2v-.2h2c1.2 0 2.2-1 2.2-2.2s-1-2.2-2.2-2.2m-45.9 4.7c0 1.5-1.2 2.7-2.7 2.7S9.7 36 9.7 34.5v-4.9c0-1.5 1.2-2.7 2.7-2.7s2.7 1.2 2.7 2.7zm39.2 0c0 1.5-1.2 2.7-2.7 2.7S49 35.9 49 34.5v-4.9c0-1.5 1.2-2.7 2.7-2.7s2.7 1.2 2.7 2.7v4.9z" />
  </svg>
);
export default IconDumbbell;
